export default "__VITE_ASSET__BmRSLPV7__"